import { render, staticRenderFns } from "./Simple.vue?vue&type=template&id=60025b54&functional=true"
var script = {}


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/assets/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60025b54')) {
      api.createRecord('60025b54', component.options)
    } else {
      api.rerender('60025b54', component.options)
    }
    module.hot.accept("./Simple.vue?vue&type=template&id=60025b54&functional=true", function () {
      api.rerender('60025b54', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "static/js/components-wa/PageHeader/Simple.vue"
export default component.exports